export function getUserType(_a) {
    var type = _a.type;
    return type === 'super group' ? 'super' : type;
}
//# sourceMappingURL=helpers.js.map